import React from 'react';
import { calcularInfoParcialidad } from '../utilities/historialParcial';

const VistaHistorialExternos = ({ infoEntidad, user, setVistaActual, cargandoHistorial, datosHistorial }) => {
  const infoParcialidad = calcularInfoParcialidad(datosHistorial);

  return (
    <div style={{ marginTop: '20px', fontFamily: 'sans-serif' }}>
      <div className="catalogo-section" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h2 style={{ color: '#003366', margin: '0 0 8px 0', fontSize: '22px' }}>Historial de: {infoEntidad.nombre || 'Externo'}</h2>
          <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
            <strong>Matrícula:</strong> {infoEntidad.matricula} &nbsp;|&nbsp; <strong> Plantel:</strong> {user?.nombre_plantel}
          </p>
        </div>
        <button className="cobro-layout btn-logout" onClick={() => setVistaActual('cobro')} style={{ width: 'auto', padding: '12px 24px', backgroundColor: '#d9534f' }}>
          ← Volver a Búsqueda
        </button>
      </div>

      <div className="catalogo-section">
        <div className="catalogo-header"><h3>Historial de Pagos Realizados</h3></div>
        {cargandoHistorial ? (
          <p style={{ padding: '20px', color: '#666' }}>⏳ Cargando historial de pagos...</p>
        ) : datosHistorial.length > 0 ? (
          <div className="table-responsive">
            <table className="results-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>ID Transacción</th>
                  <th>Banco</th>
                  <th>Referencia / Folio</th>
                  <th>Conceptos</th>
                  <th>Método</th>
                  <th>Importe</th>
                  <th>Estatus</th>
                </tr>
              </thead>
              <tbody>
                {datosHistorial.map((pago, index) => {
                // Estandarizamos el texto del banco a mayúsculas y eliminamos espacios
                const bancoUpper = String(pago.banco || '').toUpperCase().trim();
                
                const esBanorte = bancoUpper === 'BANORTE' || bancoUpper === '1';
                const esBbva = bancoUpper === 'BBVA' || bancoUpper === '2';

                const textoBanco = esBanorte ? 'BANORTE' : esBbva ? 'BBVA' : (pago.banco || 'N/A');
                const colorBanco = esBanorte ? '#eb0029' : esBbva ? '#004481' : '#555';
                const parcialidad = infoParcialidad(pago);

                return (
                  <tr key={index} style={parcialidad ? { backgroundColor: '#fff8e1' } : undefined}>
                    <td>{pago.fecha_pago}</td>

                    <td style={{ fontSize: '0.85rem' }}>
                      {parcialidad ? (
                        <span
                          title={`Parcial ${parcialidad.numero} de este pago (folio ${parcialidad.folio})`}
                          style={{
                            fontFamily: 'monospace', fontWeight: 'bold', color: '#8a6d00',
                            backgroundColor: '#ffe082', padding: '3px 8px', borderRadius: '10px'
                          }}
                        >
                          🔗 P{parcialidad.numero}-{parcialidad.folio}
                        </span>
                      ) : (
                        <span style={{ fontFamily: 'monospace', color: '#555' }}>{pago.id}</span>
                      )}
                    </td>

                    {/* CELDA CON EVALUACIÓN CASE-INSENSITIVE */}
                    <td style={{ fontWeight: 'bold', color: colorBanco }}>
                      {textoBanco}
                    </td>

                    <td style={{ fontFamily: 'monospace' }}>{pago.folio_pago || pago.referencia}</td>
                    <td>{pago.conceptos || infoEntidad.tipo}</td>
                    <td>{pago.metodo_pago || 'VENTANILLA'}</td>
                    <td style={{ fontWeight: 'bold' }}>
                      ${parseFloat(pago.importe_total || pago.importe).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                    </td>
                    <td>
                      <span style={{ backgroundColor: '#e6f4ea', color: '#137333', padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>
                        PAGADO
                      </span>
                    </td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px', color: '#aaa', fontStyle: 'italic' }}>
            No se encontraron pagos registrados.
          </div>
        )}
      </div>
    </div>
  );
};

export default VistaHistorialExternos;